import { FormHelperText, Stack, Typography } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import ExperienceChargesForm from './ExperienceChargesForm';

interface Props {
    experienceType: string;
    isEditing: boolean;
}

const ExperienceCharges = ({ experienceType, isEditing }: Props) => {
    const {
        formState: { errors },
    } = useFormContext();
    return (
        <>
            <div>
                <Typography variant='h3'>Set Pricing</Typography>
                <Typography variant='body2' sx={{ color: 'text.secondary' }}>
                    This is your standard, fixed price. It stays the same every
                    day unless you manually change it. Great for simple,
                    consistent pricing. The price you set applies to all future
                    reservations.
                </Typography>
            </div>
            {errors?.charges && (
                <FormHelperText
                    error
                    sx={{
                        fontSize: '12px',
                        mt: '5px',
                    }}
                >
                    {errors.charges.message as string}
                </FormHelperText>
            )}
            <ExperienceChargesForm
                experienceType={experienceType}
                isEditing={isEditing}
            />
        </>
    );
};

export default ExperienceCharges;
